export default __webpack_public_path__ + "img/1_15-d79c4c51.png";